export default __webpack_public_path__ + "static/media/vayuda_turquoise_fragment.d4888df5.png";